import StructuralUnitIcon from "@mui/icons-material/School";
import { AdministrationServicePath, PROFESSIONAL_DIRECTIONS } from "../../../utils/constants";
import ListDirections from "./List";
import CreateDirections from "./Create";
import EditDirections from "./Edit";
import ShowDirections from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <StructuralUnitIcon />,
  name: AdministrationServicePath + PROFESSIONAL_DIRECTIONS,
  title: "Професионални направления",
  list: <ListDirections />,
  create: <CreateDirections />,
  createPermission: permissions.canCreateProfessionalDirections,
  edit: <EditDirections />,
  editPermission: permissions.canUpdateProfessionalDirections,
  show: <ShowDirections />,
  showPermission: permissions.canPreviewProfessionalDirections,
  permission: permissions.canPreviewProfessionalDirections,
};
